import React from 'react';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section id="inicio" className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden bg-crema" data-id="element-129">
      {/* Subtle background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-130">
        <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] rounded-full bg-rosa/20 blur-3xl opacity-60" data-id="element-131" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[60%] h-[60%] rounded-full bg-durazno/20 blur-3xl opacity-60" data-id="element-132" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10" data-id="element-133">
        {/* Text Content */}
        <div className="max-w-xl" data-id="element-134">
          <FadeIn delay={0.1} data-id="element-135">
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.1] text-texto mb-6" data-id="element-136">
              Conocer tu cuerpo también es una forma de cuidarte
            </h1>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-137">
            <p className="font-sans text-lg md:text-xl text-textoSuave mb-10 leading-relaxed" data-id="element-138">
              Ebooks y recursos digitales sobre el cuerpo femenino, sus cambios,
              sus procesos y las experiencias reales que muchas mujeres viven en
              silencio.
            </p>
          </FadeIn>

          <FadeIn delay={0.5} className="flex flex-wrap gap-4" data-id="element-139">
            <a href="#ebooks" className="inline-flex items-center justify-center px-8 py-3.5 rounded-full bg-rosa text-texto font-medium hover:bg-durazno transition-colors duration-300" data-id="element-140">
              Ver ebooks
            </a>
            <a href="#temas" className="inline-flex items-center justify-center px-8 py-3.5 rounded-full border border-texto/20 text-texto font-medium hover:bg-blanco transition-colors duration-300" data-id="element-141">
              Explorar temas
            </a>
            <a href="#nosotros" className="inline-flex items-center justify-center px-8 py-3.5 rounded-full text-textoSuave font-medium hover:text-texto transition-colors duration-300" data-id="element-142">
              Conocer la marca
            </a>
          </FadeIn>
        </div>

        {/* Abstract Illustration */}
        <FadeIn delay={0.4} direction="left" className="relative w-full mx-auto flex items-center justify-center md:scale-125 lg:scale-150 origin-center" data-id="element-143">
          <img src="https://cdn.magicpatterns.com/uploads/iDAMjcyHAa8xfv8PzT2omG/habitando_mi_cuerpo_exportado_(1)_(1).png" alt="Habitando mi cuerpo — ilustración" className="w-full max-w-xl md:max-w-2xl lg:max-w-3xl object-contain opacity-40" data-id="element-144" />
        </FadeIn>
      </div>
    </section>;
}